import { h } from 'preact'
import classNames from 'clsx'

import { getDisplayName } from '../../utils'
import { SIDE_LEFT, SIDE_RIGHT } from '../../../constants'

import styles from './index.module.scss'

const Floating = (Component, displayName) => {
  const WrappedComponent = ({ className, float, ...props }) => (
    <Component
      {...props}
      className={buildFloatingClassName({
        className,
        float,
        side: float,
      })}
    />
  )

  WrappedComponent.displayName = displayName || `Floating(${getDisplayName(Component)})`

  return WrappedComponent
}

export function buildFloatingClassName({ className, float, side }) {
  return classNames(
    className,
    {
      [styles['u-floating']]: float,
      [styles['u-floating--left']]: side === SIDE_LEFT,
      [styles['u-floating--right']]: side === SIDE_RIGHT,
    },
  )
}

export default Floating
